<template>

</template>

<script>
export default {
    mounted() {
        //用于跳转到登录页
        const host = location.host
        if (host.indexOf("localhost") != -1) {
            window.location.href = "http://localhost:8080/share/sign";
        } else if (host.indexOf("test.multcloud.com") != -1) {
            window.location.href = "https://test.multcloud.com/sign";
        } else {
            window.location.href = "https://www.multcloud.com/sign.html";
        }
    },
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/turn_login_page.vue